import React, { Component } from 'react'

export default class ActionBar extends Component {
  render () {
    return <div className='action-bar'>
      {this.props.children}
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/ActionBar.js